import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { Accordion, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { JSHINT as jshint } from 'jshint';
import PureEditor from '../pureEditor';
import ErrorMessage from '../errorMessage';
import ConsoleLog from '../consoleLog';
import TestCase from '../testCase';
import { runTest, defaultTestCase, saveTest, getCodeTestcase } from './../../utils';
import { bizzBuzz, dump, greet, primeFactors, createMyOwn, recentlyList } from './../../testLib';
import './index.scss';
import useToast from './../../hooks/useToast';
import TestFormModal from '../testFormModal';
import { v4 as uuidv4 } from 'uuid';
import { getKataById, updateTest } from '../../services/apiService';
import SaveButton from './saveButton';
import { useApp } from '../../contexts/useApp';

window.JSHINT = jshint;

const code = `// 'console.log' is available for debug
const test=(val) => {
  return val;
};`;

const testFromFile = createMyOwn;

let editor;

const Tdd = () => {
  const history = useHistory();
  const { state, action, get } = useApp();
  const { slug, id, forkid } = useParams();
  const isReadOnly = slug && id;
  const [initTests, setInitTest] = useState([]);
  const [testCaseDefaultValue, setTestCaseDefaultValue] = useState({
    defaultTestCase,
  });
  const { setMessage, setMessageBg, setIsShown, Toast } = useToast();
  const [status, setStatus] = useState(0);
  const [errors, setErrors] = useState([]);
  const [logs, setLogs] = useState([]);
  const [value, setValue] = useState(code);
  const [tests, setTests] = useState([]);
  const [runDisabled, setRunDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [question, setQuestion] = useState('');
  const [showEditor, setShowEditor] = useState(true);
  const [questionTitle, setQuestionTitle] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [canReviewCodeSnap, setCanReviewCodeSnap] = useState(false);
  const [userId, setUserId] = useState();
  const [publishedAndLevel, setPublishedAndLevel] = useState();
  const [newKataId, setNewKataId] = useState();

  const initEditor = () => {
    //set editor
    editor = window.CKEDITOR.replace('test', {
      uiColor: 'rgba(0,0,0,.03)',
      // removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor',

      colorButton_foreStyle: {
        element: 'font',
        attributes: { color: '#(color)' },
      },
      colorButton_backStyle: {
        element: 'font',
        styles: { 'background-color': '#(color)' },
      },
    }).on('change', function () {
      setQuestion(this.getData());
    });
  };

  useEffect(() => {
    if (forkid) {
      // Not editable
      getKataById(forkid)
        .then(({ data }) => {
          const json = JSON.parse(data.jsonContent);
          setUserId(data.user.id);
          // setPublishedAndLevel({ isPublished: data.isPublished, level: data.level });
          cloneKata(json);
          initEditor();
        })
        .catch(error => error)
        .finally(() => {});

      return;
    }
    if (isReadOnly) {
      // Not editable
      getKataById(id)
        .then(({ data }) => {
          const json = JSON.parse(data.jsonContent);
          setUserId(data.user.id);
          setPublishedAndLevel({ isPublished: data.isPublished, level: data.level });
          loadKata(json);
        })
        .catch(error => error)
        .finally(() => {});
    } else {
      setInitTest(testFromFile);
      setTests(testFromFile.slice(0, 1));
      //clear editor and title
      setQuestionTitle('');
      setQuestion('');
      setValue(code);
      setPublishedAndLevel();

      initEditor();
    }
  }, [isReadOnly]);

  const onChange = (editor, data, value) => {
    setValue(value);
    setErrors(checkErrors(value));
  };

  const checkErrors = value => {
    jshint(value.split('\n'), { esversion: 9 });

    const errors = jshint.data().errors ?? [];
    if (errors.length) {
      setRunDisabled(true);
    } else {
      setRunDisabled(false);
    }

    return errors;
  };

  const alertMsg = (msg, isSuccess) => {
    setIsShown(true);
    if (isSuccess) {
      setMessageBg('success');
    } else {
      setMessageBg('danger');
    }
    setMessage(msg);
    setTimeout(() => setIsShown(false), 2000);
  };

  const runTests = () => {
    setErrors([]);
    setLogs([]);
    try {
      runTest(
        value,
        tests,
        setTests,
        setErrors,
        setStatus,
        status,
        initTests,
        alertMsg,
        setInitTest,
        setLogs
      );
    } catch (error) {
      // @TODO this currently do nothing
      console.log(error);
    }
  };

  // const saveNewTest = data => {
  //   setTests(prev => {
  //     return [
  //       ...prev,
  //       {
  //         id: uuidv4(),
  //         title: data.title ?? '',
  //         code: data.code ?? '',
  //         outcome: null,
  //         isAdded: true,
  //         codeSnap: '',
  //       },
  //     ];
  //   });
  //   setIsOpen(false);
  // };
  const saveNewTest = data => {
    const item = {
      id: uuidv4(),
      title: data.title ?? '',
      code: data.code ?? '',
      outcome: null,
      isAdded: true,
      codeSnap: '',
    };
    const testLen = tests.length;
    setTests(prev => {
      return [...prev, item];
    });
    setInitTest(prev => {
      return [...prev.slice(0, testLen), item, ...prev.slice(testLen, prev.length)];
    });
    setStatus(testLen + 1);
    setIsOpen(false);
  };

  const cloneKata = json => {
    // save the last code snap as value
    if (json.cases.length) {
      setValue(json.cases[json.cases.length - 1].codeSnap);
    } else {
      setValue(json.test.code);
    }

    setQuestion(json.question);
    setQuestionTitle(json.title);

    if (!json.cases.length) {
      return;
    }
    const cases = json.cases.map(test => ({ ...test, isAdded: true }));
    setInitTest(cases);
    setTests(cases);
    setStatus(cases.length - 1);
  };

  const loadKata = (json, question = true) => {
    if (!question) {
      setValue(json.test.code);
    }
    setInitTest(json.cases);
    setTests(json.cases.slice(0, 1));
    setQuestion(json.question);
    setQuestionTitle(json.title);
    if (editor) editor.setData(json.question);
    setStatus(0);
  };

  // const loadFromStorage = () => {
  //   const json = getCodeTestcase();

  //   if (!json) return;

  //   loadKata(json);
  // };

  const reviewCodeSnap = index => {
    setValue(initTests[index].codeSnap);
    setTests(initTests.slice(0, index + 1));
    setStatus(index);
  };

  // blue #30A3F1 orange #F49E63 grey

  const saveKata = async ({ isPublished, level }, save = true) => {
    if (!(state.profile.username && state.profile.id)) {
      alert('Please login to save your test case.');
      return;
    }

    setIsSaving(true);
    try {
      if (save) {
        if (!newKataId) {
          const data = await saveTest(
            question,
            questionTitle,
            value,
            tests,
            { isPublished, level },
            false
          );
          setNewKataId(data.kata.id);
        } else {
          const jsonContent = JSON.stringify({
            title: questionTitle,
            question,
            test: { code: value },
            cases: tests.map(test => ({ ...test, outcome: null, isAdded: false })),
          });
          updateTest(newKataId, { jsonContent });
        }
      } else {
        updateTest(id, { isPublished, level: level ? Number(level) : 0 });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSaving(false);
    }
  };

  const enableReview = () => {
    setCanReviewCodeSnap(true);
  };

  return (
    <>
      <Toast />
      <div className="wrapper">
        <Accordion className="question">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <span>Requirement</span>
              {isReadOnly && (
                <a
                  onClick={e => {
                    e.stopPropagation();
                    if (!state.profile.username) {
                      const setIsLoginFormModalOpen = get('setIsLoginFormModalOpen');
                      if (typeof setIsLoginFormModalOpen === 'function') {
                        setIsLoginFormModalOpen(true);
                      }
                      return;
                    }
                    history.push(`/kata/${id}/fork`);
                  }}
                  className="question_fork-link"
                >
                  Fork the Kata
                </a>
              )}
            </Accordion.Header>
            <Accordion.Body>
              {isReadOnly ? (
                <div
                  className="cke_contents_ltr question-readOnly"
                  dangerouslySetInnerHTML={{ __html: question }}
                />
              ) : (
                <div id="test" dangerouslySetInnerHTML={{ __html: question }} />
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <h1 className="question-title">
          <Form.Control
            placeholder="Enter question title"
            value={questionTitle}
            onChange={e => setQuestionTitle(e.target.value)}
          />
        </h1>
        <div className="test-block-wrapper">
          <div className="editor test-block">
            <PureEditor
              resizable
              value={value}
              options={{
                readOnly: false,
                mode: 'javascript',
                lineNumbers: true,
                lint: { esversion: 9 },
                gutters: ['CodeMirror-lint-markers'],
                theme: 'material',
                innerHeight: 900,
              }}
              onChange={onChange}
            />
            <ConsoleLog logs={logs} />
            <ErrorMessage errors={errors} />
            <div className="test-block_buttons">
              {(!isReadOnly || state.profile.id === userId) && (
                <SaveButton
                  value={value}
                  title={questionTitle}
                  question={question}
                  tests={tests}
                  saveKata={saveKata}
                  runDisabled={runDisabled}
                  isSaving={isSaving}
                  publishedAndLevel={publishedAndLevel}
                />
              )}
              {/* <Button variant="info" onClick={loadFromStorage} disabled={runDisabled}>
                Load from Storage
              </Button> */}
              <Button
                variant="info"
                onClick={runTests}
                disabled={runDisabled}
                className="run-test-btn"
              >
                Run test
              </Button>
            </div>
            {isReadOnly && (
              <div className="editor_review-btn" onClick={enableReview}>
                Review production code step by step with each test case
              </div>
            )}
          </div>
          <div className="tests test-block">
            {tests &&
              tests.map((test, index) => (
                <TestCase
                  canReviewCodeSnap={canReviewCodeSnap}
                  isReadOnly={isReadOnly}
                  key={index}
                  index={index}
                  count={tests.length}
                  onChange={value => {
                    const copiedTests = JSON.parse(JSON.stringify(tests));
                    copiedTests[index].code = value;
                    setTests(copiedTests);
                  }}
                  test={test}
                  reviewCodeSnap={() => reviewCodeSnap(index)}
                  snapCode={() => {
                    const copiedTests = JSON.parse(JSON.stringify(tests));
                    copiedTests[index].codeSnap = value;
                    setTests(copiedTests);
                  }}
                  moveUp={() => {
                    if (index === 0) return;
                    setTests(prev => {
                      return prev.map((t, i) => {
                        if (i === index - 1) return tests[index];
                        if (i === index) return tests[index - 1];
                        return t;
                      });
                    });
                  }}
                  moveDown={() => {
                    if (index >= tests.length) return;
                    setTests(prev => {
                      return prev.map((t, i) => {
                        if (i === index) return tests[index + 1];
                        if (i === index + 1) return tests[index];
                        return t;
                      });
                    });
                  }}
                  deleteCase={() => {
                    setTests(prevTests => {
                      return prevTests.filter((_, i) => i !== index);
                    });
                  }}
                  options={{
                    readOnly: !test.isAdded,
                    mode: 'javascript',
                    lineNumbers: true,
                    lint: { esversion: 6 },
                    gutters: ['CodeMirror-lint-markers'],
                    theme: 'material',
                  }}
                />
              ))}
            <div className="test-block_test-case_buttons">
              <Button
                varian="primary"
                onClick={() => {
                  setIsOpen(true);
                  setTestCaseDefaultValue(defaultTestCase);
                }}
              >
                Add test
              </Button>
            </div>
          </div>
        </div>
      </div>
      <TestFormModal
        defaultTestCase={{ defaultTestCase }}
        isOpen={isOpen}
        submitForm={saveNewTest}
        handleClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default Tdd;
